import { DataTable } from "primereact/datatable";
import { format } from "date-fns";
import { Column } from "primereact/column";
import { useEffect, useRef, useState } from "react";

import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { baseUrl, Fetch } from "../../../shared/Fetch";
import { ITimesheet } from "../../../models/Timesheet";
import { IRecRepFilter } from "./Filter";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { ILogin } from "../../../models/Login";

interface IProps {
    singleData: any,
    open: boolean,
    hideDialog: () => void,
    reloadDialog: () => void,
    toast: any,
    setReload: (is: boolean) => void,
    po?: any,
    recent: any,
    timeSheetCount: number,
    filter: IRecRepFilter,
}

export const AutoFillTimeSheet = (props: IProps) => {
    const [timeSheetData, setTimeSheetData] = useState<any | null>(null);
    const [recentData, setRecentData] = useState<ITimesheet | null>(null);
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: any[], loading: boolean });
    const [timesheetFile, setTimesheetFile] = useState<File | null | any>(null);
    const [timeSheetDateLeft, setTimeSheetDateLeft] = useState<string[] | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [editRowIndex, setEditRowIndex] = useState<number | null>(null);
    const dt = useRef<any>(null);

    const from_Date = (rowData: any, rowIndex: number) => {
        let date;
        if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";

        return (
            (editRowIndex != null && editRowIndex === rowIndex) ?
                <div className={'field col-12 md:col-12'}>
                    <Calendar view={"date"} value={rowData.fromDate} onChange={(e) => {
                        tableData.tableData[rowIndex].toDate = e.target.value;
                        setTableData({ tableData: tableData.tableData, loading: false });
                    }} disabled={false} placeholder={""} showButtonBar dateFormat={"dd-mm-yy"} showIcon />
                </div>
                :
                <>{date}</>
        );
    }
    const to_Date = (rowData: any, rowIndex: number) => {
        let date;
        if (rowData.toDate) date = format(new Date(rowData.toDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return ((editRowIndex != null && editRowIndex === rowIndex) ?
            <div className={'field col-12 md:col-12'}>
                <Calendar view={"date"} value={rowData.toDate} onChange={(e) => {
                    tableData.tableData[rowIndex].toDate = e.target.value;
                    setTableData({ tableData: tableData.tableData, loading: false });
                }} disabled={false} placeholder={""} showButtonBar dateFormat={"dd-mm-yy"} showIcon />
            </div>
            :
            <>{date}</>
        );
    }


    const onHide = () => {
        setTimeSheetData(null);
        setRecentData(null);
        setTableData({ tableData: [], loading: false });
        setTimesheetFile(null);
        setLoading(false);
        setEditRowIndex(null);
        props.hideDialog();
    };

    useEffect(() => {
        if (props.open) {
            setRecentData(prev => prev = props.recent);
            setRecentData(prev => prev = props.recent);
            setTimeSheetData({
                ...props.singleData,
                pO_ID: props.recent?.pO_ID,
                consultant_ID: props.recent?.consultant_ID,
            });
        };
    }, [props.open, recentData]);

    const header = () => {
        return <span>Pending Timesheets for -<span style={{ color: "red" }}>({recentData?.consultantName})</span>  </span>
    }

    const getLefTimeSheetsData = async (poID: number) => {
        let filterOfDate = '';
        if (props.filter?.fromDate && props.filter?.toDate) {
            const fromDate = new Date(props.filter?.fromDate || "");
            const toDate = new Date(props.filter?.toDate || "");
            filterOfDate = `&dateFilter=${JSON.stringify({ fromDate: fromDate, toDate: toDate })}`;
        } else if (props.filter?.fromDate) {
            const fromDate: Date = new Date(props.filter?.fromDate || "");
            filterOfDate = `&dateFilter=${JSON.stringify({ fromDate: fromDate })}`;
        }
        else if (props.filter?.toDate) {
            const toDate: Date = new Date(props.filter?.toDate || "");
            filterOfDate = `&dateFilter=${JSON.stringify({ toDate: toDate })}`;
        };

        const response = await Fetch("ResourceTimesheet/getLeftTimeSheetDates", "GET", null, `PO_ID=${poID}&byInternal=1` + filterOfDate, null);
        if (response) {
            const data = await response.json();
            setTimeSheetDateLeft(data);
        }
    }

    useEffect(() => {
        if (props.open) {
            if (props?.singleData?.pO_ID) {
                getLefTimeSheetsData(props?.singleData?.pO_ID);
            }
        };
    }, [props.open, recentData]);

    useEffect(() => {
        // if (timeSheetData !== null) {
        //     //  console.log("A");
        //     // console.log("props.timeSheetCount : " + props.timeSheetCount + " , tableData.tableData.length : " + tableData.tableData.length)
        //     // console.log("props.timeSheetCount > tableData.tableData.length", props.timeSheetCount > tableData.tableData.length);
        //     if (props.timeSheetCount > tableData.tableData.length) {
        //         //  console.log("B");
        //         setTableData({ tableData: tableData.tableData, loading: true });
        //         //  console.log(`fromDate : ${timeSheetData.fromDate} , toDate : ${timeSheetData.toDate} , data : `, timeSheetData);
        //         if (recentData?.toDate === null || recentData === undefined) {
        //             //  console.log("C");

        //             timeSheetData.fromDate = new Date(props?.recent?.project_Start_Date || "");
        //             const currentDate = new Date(props?.recent?.project_Start_Date || "");
        //             let numberOfDaysToAdd = (7 - Number(new Date(props?.recent?.project_Start_Date || "")?.getDay())) - 2;
        //             const toDate = new Date(currentDate.setDate(currentDate.getDate() + numberOfDaysToAdd));
        //             timeSheetData.toDate = toDate;
        //             setTableData(prev => prev = { tableData: [...tableData.tableData, timeSheetData], loading: false });
        //             setRecentData(prev => prev = timeSheetData);
        //         } else if (recentData?.toDate && recentData?.toDate !== null) {
        //             //  console.log("D");
        //             const fromDate = new Date(new Date(recentData.toDate || "").setDate(new Date(recentData.toDate || "").getDate() + 3));
        //             timeSheetData.fromDate = fromDate;
        //             const toDate = new Date(new Date(recentData.toDate || "").setDate(new Date(recentData.toDate || "").getDate() + 7));
        //             timeSheetData.toDate = toDate;
        //             //  console.log(`fromDate : ${recentData.fromDate} , toDate : ${recentData.toDate} , data : `, timeSheetData);
        //             setTableData(prev => prev = { tableData: [...tableData.tableData, timeSheetData], loading: false });
        //             setRecentData(prev => prev = timeSheetData);
        //         };
        //     };
        // }
        if (timeSheetDateLeft != null && timeSheetDateLeft.length > 0) {
            setTableData(prev => prev = { tableData: tableData.tableData, loading: true });
            let data: any[] = timeSheetDateLeft.map((e) => {
                let newData: any = { pO_ID: props?.po?.pO_ID };
                const fromDate = new Date(e || "");
                newData.fromDate = fromDate;
                const toDate = new Date(new Date(e || "").setDate(new Date(e || "").getDate() + 6));
                newData.toDate = toDate;
                return newData;
            });
            setTableData(prev => prev = { tableData: data, loading: false });
            // setRecentData(prev => prev = timeSheetData);
        }
    }, [timeSheetDateLeft]);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format;

    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header={header} modal className="p-fluid" onHide={onHide}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "10px" }}
                    ref={dt} size="small" stripedRows showGridlines exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    value={tableData.tableData}
                //loading={tableData.loading}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                    {/* <Column field="fromDate" header="From Date" body={(rowData, options) => from_Date(rowData, options.rowIndex)} /> 
                     <Column field="toDate" header="To Date" body={(rowData, options) => to_Date(rowData, options.rowIndex)} />  */}
                    <Column field="fromDate" header="From Date" body={(rowData: any) => {
                            const dateStr =  typeof rowData.fromDate === "string" ? rowData.fromDate : rowData.fromDate.toISOString();
                            const parts = dateStr.split("T")[0].split("-");
                            return (<span> {safeFormatDate( new Date(  Number(parts[0]), Number(parts[1]) - 1, Number(parts[2])).toDateString(), "dd/MM/yyyy", DateFormat )}</span>
                            ); }}
                    />
                    <Column field="toDate" header="To Date" body={(rowData: any) => {
                            const dateStr = typeof rowData.toDate === "string" ? rowData.toDate : rowData.toDate.toISOString();
                            const parts = dateStr.split("T")[0].split("-");
                            return ( <span>{safeFormatDate(  new Date(  Number(parts[0]),  Number(parts[1]) - 1, Number(parts[2]) ).toDateString(), "dd/MM/yyyy",  DateFormat )} </span>
                            ); }}
                    />
                </DataTable>
            </Dialog>
        </>
    );
}